import { replace as routerReplace } from 'react-router-redux'
import statusActions from '../status/status-actions'
import navigationActions from '../navigation/navigation-actions'


// For convienience and consitency, we use changeRoute instead of importing react-routers actions.
// We must ensure consistency so we don't break the navigation functionality
export const changeRoute = (route) => (dispatch, getState) =>{
    // We don't handle this in the reducer, but we dispatch this action so that we can see it in the Redux debug tools
    dispatch({
        type: "CHANGE_ROUTE",
        route
    })
    dispatch(routerReplace(route));
}

// Once we hit a certain page we may want to disable certain routes. Clicking the back button will disallow navigating to
// the disabled routes.
export const disableRoutes = (disabledRoutes) => ({
    type: "DISABLE_ROUTES",
    disabledRoutes
})

// Once we hit a certain page we might want to disable the form close warning. This typically happends when the form is completed
// or when we have caused a redirection to another webpage.
export const setCloseWarning = (value:boolean) => ({
    type: "SET_CLOSE_WARNING",
    value
})

// Internal: This is used to reset the form when accessing an invalid route
export const resetForm = () => (dispatch, getState) => {
    dispatch( navigationActions.changeRoute("/step-1") )
    dispatch( statusActions.showLoading("reset form") )
    dispatch( setCloseWarning(false) )
    
    dispatch( (dispatch, getState) => {
        window.location.reload();
    })
}

// Internal: This is used to reset the form when accessing an invalid route and maintenance flag is set
export const resetFormInMaintenance = () => (dispatch, getState) => {
    dispatch( navigationActions.changeRoute("/maintenance") )
    dispatch( statusActions.showLoading("reset form") )
    dispatch( setCloseWarning(false) )

    dispatch( (dispatch, getState) => {
        window.location.reload();
    })
}



export default {
    changeRoute,
    disableRoutes,
    setCloseWarning,
    resetForm,
    resetFormInMaintenance
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/navigation/navigation-actions.ts